export const CardPositionType = {
  Initial: 0,
  Answer: 1,
} as const;

// eslint-disable-next-line
export type CardPositionType =
  typeof CardPositionType[keyof typeof CardPositionType];
